import PropTypes from 'prop-types';
import React from 'react';
import {FluidRatio} from 'components/Ratio';
import CardHeader from '../shared/CardHeader';
import SummaryNumber from 'components/VisualizationStrategies/SummaryNumber';
import PdpNotice from 'components/PdpNotice';
import phoenixRender, {SIZES, PARTS} from './phoenixRender';
import './ChartCard.css';

class ChartCard extends React.Component {
  render() {
    const {card, chartRender, isLoaded, width, height} = this.props;

    const summary =
      chartRender && chartRender.summary ? (
        <SummaryNumber
          number={chartRender.summary.value}
          label={chartRender.summary.label}
        />
      ) : null;

    const image =
      isLoaded && chartRender && chartRender.image ? (
        <div className="ChartCard__Center">
          <img
            src={`data:image/png;base64,${chartRender.image.data}`}
            width={width}
            height={height}
            className="ChartCard__Image"
          />
        </div>
      ) : (
        <div
          className="ChartCard__Placeholder ChartCard__Center"
          style={{
            width,
            height,
          }}
        />
      );

    return (
      <div>
        <CardHeader card={card} />
        {summary}
        <div className="ChartCard__ImageContainer">{image}</div>
        <PdpNotice chartRender={chartRender} />
      </div>
    );
  }
}

ChartCard.propTypes = {
  card: PropTypes.object.isRequired,
  filters: PropTypes.array,
};

const PhoenixChartCard = phoenixRender(
  ({isResizing, filters, height, width}) => ({
    filters,
    isResizing,
    width,
    height,
    size: SIZES.MEDIUM,
    parts: [PARTS.SUMMARY, PARTS.PDP, PARTS.IMAGE],
  })
)(ChartCard);

export default props => (
  <div className="ChartCard">
    <FluidRatio x={2} y={1}>
      {(width, height, hasComputed) => (
        <PhoenixChartCard
          {...props}
          width={width}
          height={height}
          isResizing={!hasComputed}
        />
      )}
    </FluidRatio>
  </div>
);
